export default __webpack_public_path__ + "static/media/Landing.5dcbd92c.gif";